import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { WindIcon, MoonIcon, BrainIcon, ActivityIcon } from 'lucide-react';
const symptoms = [{
  icon: WindIcon,
  title: 'Bloating',
  description: 'Waking up flat but feeling six months pregnant by 4 PM.'
}, {
  icon: MoonIcon,
  title: '3 AM Insomnia',
  description: 'Exhausted all day, but wide awake when your head hits the pillow.'
}, {
  icon: BrainIcon,
  title: 'Brain Fog',
  description: 'Relying on three cups of coffee just to remember your morning meetings.'
}, {
  icon: ActivityIcon,
  title: 'Stress Belly',
  description: 'Stubborn weight around the midsection that ignores your diet.'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: 'easeOut'
    }
  }
};
export function Symptoms() {
  return <section className="py-24 bg-white" data-id="element-125">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-126">
        <div className="text-center max-w-2xl mx-auto mb-16" data-id="element-127">
          <h2 className="text-3xl md:text-4xl font-semibold mb-4" data-id="element-128">
            Sound familiar?
          </h2>
          <p className="text-teal-muted text-lg" data-id="element-129">
            High cortisol doesn't just make you feel stressed. It fundamentally
            changes how your body stores fat, digests food, and rests.
          </p>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-130">
          {symptoms.map((symptom, index) => <motion.div key={index} variants={itemVariants} className="p-8 border border-cream-dark bg-cream/30 hover:bg-cream transition-colors duration-300 flex flex-col items-center text-center group" data-id="element-131">
              <div className="w-12 h-12 rounded-full bg-sage-light flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300" data-id="element-132">
                <symptom.icon className="w-6 h-6 text-sage" data-id="element-133" />
              </div>
              <h3 className="text-xl font-medium mb-3" data-id="element-134">{symptom.title}</h3>
              <p className="text-teal-muted text-sm leading-relaxed" data-id="element-135">
                {symptom.description}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}